module.exports = __webpack_public_path__ + "static/media/facebook.e7c435af.png";